namespace Matrix.Data {
    export interface AccountTypeRow {
        AccountTypeCode?: string;
        Name?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace AccountTypeRow {
        export const idProperty = 'AccountTypeCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Data.AccountType';
        export const lookupKey = 'Data.AccountType';

        export function getLookup(): Q.Lookup<AccountTypeRow> {
            return Q.getLookup<AccountTypeRow>('Data.AccountType');
        }
        export const deletePermission = 'DataAdmin:AccountType';
        export const insertPermission = 'DataAdmin:AccountType';
        export const readPermission = 'Read:AccountType';
        export const updatePermission = 'DataAdmin:AccountType';

        export declare const enum Fields {
            AccountTypeCode = "AccountTypeCode",
            Name = "Name",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
